export default __webpack_public_path__ + "4cb954f89ff9c9cc545c0f898390338e.png";